import React, {
  createContext,
  useContext,
  useReducer,
  useEffect,
  useState,
} from "react";

const CartContext = createContext(null);

// Customised items get their own line per unit (each carries its own name);
// everything else is one line per product.
export const cartKey = (item) => item.cartKey || item._id;

let lineSeq = 0;

function cartReducer(state, action) {
  switch (action.type) {
    case "ADD": {
      if (action.item.customName) {
        const key = `${action.item._id}:${Date.now()}:${lineSeq++}`;
        return [...state, {...action.item, cartKey: key, qty: 1}];
      }
      const existing = state.find((i) => cartKey(i) === action.item._id);
      if (existing)
        return state.map((i) =>
          i === existing ? {...i, qty: i.qty + 1} : i,
        );
      return [...state, {...action.item, cartKey: action.item._id, qty: 1}];
    }
    case "REMOVE":
      return state.filter((i) => cartKey(i) !== action.id);
    case "SET_QTY":
      return state.map((i) =>
        cartKey(i) === action.id ? {...i, qty: Math.max(1, action.qty)} : i,
      );
    case "CLEAR":
      return [];
    default:
      return state;
  }
}

function loadCart() {
  try {
    return JSON.parse(localStorage.getItem("shop_cart")) || [];
  } catch {
    return [];
  }
}

export function CartProvider({children}) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [cart, dispatch] = useReducer(cartReducer, [], loadCart);
  useEffect(() => {
    localStorage.setItem("shop_cart", JSON.stringify(cart));
  }, [cart]);

  const addToCart = (item) => {
    dispatch({type: "ADD", item});
    setDrawerOpen(true);
  };
  const removeFromCart = (id) => dispatch({type: "REMOVE", id});
  const setQty = (id, qty) => dispatch({type: "SET_QTY", id, qty});
  const clearCart = () => dispatch({type: "CLEAR"});
  const totalItems = cart.reduce((s, i) => s + i.qty, 0);
  const subtotal = cart.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        setQty,
        clearCart,
        totalItems,
        subtotal,
        drawerOpen,
        setDrawerOpen,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
